// Pathify
import {make} from 'vuex-pathify'
import api from "@/services/api";
import {toast} from '@/util/helpers';

// Data
const state = {
	external_resources:[],
	external_resource: {},
}

const getters = make.getters(state)

const mutations = make.mutations(state)

const actions = {
	...make.actions(state),
	getExternal_resources: ({ dispatch }) => {
		api.external_resources.index()
			.then(response => dispatch('setExternal_resources', response.data))
			.catch(error => toast.add(error.message, 'error'))
	},
	getExternal_resource: ({ dispatch }, id) => {
		api.external_resources.show(id)
			.then(response => dispatch('setExternal_resource', response.data))
			.catch(error => toast.add(error.message, 'error'))
	}

}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}
